/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type {
  FacadeControllerContextLib,
  FacadeControllerContextLibInterface,
} from "../FacadeControllerContextLib";

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IController",
            name: "controller",
            type: "address",
          },
          {
            internalType: "address[15]",
            name: "cache",
            type: "address[15]",
          },
        ],
        internalType: "struct ControllerContextLib.ControllerContext",
        name: "cc",
        type: "tuple",
      },
    ],
    name: "getDungeonFactory",
    outputs: [
      {
        internalType: "contract IDungeonFactory",
        name: "dest",
        type: "address",
      },
      {
        components: [
          {
            internalType: "contract IController",
            name: "controller",
            type: "address",
          },
          {
            internalType: "address[15]",
            name: "cache",
            type: "address[15]",
          },
        ],
        internalType: "struct ControllerContextLib.ControllerContext",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IController",
            name: "controller",
            type: "address",
          },
          {
            internalType: "address[15]",
            name: "cache",
            type: "address[15]",
          },
        ],
        internalType: "struct ControllerContextLib.ControllerContext",
        name: "cc",
        type: "tuple",
      },
    ],
    name: "getGameObjectController",
    outputs: [
      {
        internalType: "contract IGOC",
        name: "dest",
        type: "address",
      },
      {
        components: [
          {
            internalType: "contract IController",
            name: "controller",
            type: "address",
          },
          {
            internalType: "address[15]",
            name: "cache",
            type: "address[15]",
          },
        ],
        internalType: "struct ControllerContextLib.ControllerContext",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IController",
            name: "controller",
            type: "address",
          },
          {
            internalType: "address[15]",
            name: "cache",
            type: "address[15]",
          },
        ],
        internalType: "struct ControllerContextLib.ControllerContext",
        name: "cc",
        type: "tuple",
      },
    ],
    name: "getGameToken",
    outputs: [
      {
        internalType: "contract IGameToken",
        name: "dest",
        type: "address",
      },
      {
        components: [
          {
            internalType: "contract IController",
            name: "controller",
            type: "address",
          },
          {
            internalType: "address[15]",
            name: "cache",
            type: "address[15]",
          },
        ],
        internalType: "struct ControllerContextLib.ControllerContext",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IController",
            name: "controller",
            type: "address",
          },
          {
            internalType: "address[15]",
            name: "cache",
            type: "address[15]",
          },
        ],
        internalType: "struct ControllerContextLib.ControllerContext",
        name: "cc",
        type: "tuple",
      },
    ],
    name: "getGuildController",
    outputs: [
      {
        internalType: "contract IGuildController",
        name: "dest",
        type: "address",
      },
      {
        components: [
          {
            internalType: "contract IController",
            name: "controller",
            type: "address",
          },
          {
            internalType: "address[15]",
            name: "cache",
            type: "address[15]",
          },
        ],
        internalType: "struct ControllerContextLib.ControllerContext",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IController",
            name: "controller",
            type: "address",
          },
          {
            internalType: "address[15]",
            name: "cache",
            type: "address[15]",
          },
        ],
        internalType: "struct ControllerContextLib.ControllerContext",
        name: "cc",
        type: "tuple",
      },
    ],
    name: "getHeroController",
    outputs: [
      {
        internalType: "contract IHeroController",
        name: "dest",
        type: "address",
      },
      {
        components: [
          {
            internalType: "contract IController",
            name: "controller",
            type: "address",
          },
          {
            internalType: "address[15]",
            name: "cache",
            type: "address[15]",
          },
        ],
        internalType: "struct ControllerContextLib.ControllerContext",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IController",
            name: "controller",
            type: "address",
          },
          {
            internalType: "address[15]",
            name: "cache",
            type: "address[15]",
          },
        ],
        internalType: "struct ControllerContextLib.ControllerContext",
        name: "cc",
        type: "tuple",
      },
    ],
    name: "getItemBoxController",
    outputs: [
      {
        internalType: "contract IItemBoxController",
        name: "dest",
        type: "address",
      },
      {
        components: [
          {
            internalType: "contract IController",
            name: "controller",
            type: "address",
          },
          {
            internalType: "address[15]",
            name: "cache",
            type: "address[15]",
          },
        ],
        internalType: "struct ControllerContextLib.ControllerContext",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IController",
            name: "controller",
            type: "address",
          },
          {
            internalType: "address[15]",
            name: "cache",
            type: "address[15]",
          },
        ],
        internalType: "struct ControllerContextLib.ControllerContext",
        name: "cc",
        type: "tuple",
      },
    ],
    name: "getItemController",
    outputs: [
      {
        internalType: "contract IItemController",
        name: "dest",
        type: "address",
      },
      {
        components: [
          {
            internalType: "contract IController",
            name: "controller",
            type: "address",
          },
          {
            internalType: "address[15]",
            name: "cache",
            type: "address[15]",
          },
        ],
        internalType: "struct ControllerContextLib.ControllerContext",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IController",
            name: "controller",
            type: "address",
          },
          {
            internalType: "address[15]",
            name: "cache",
            type: "address[15]",
          },
        ],
        internalType: "struct ControllerContextLib.ControllerContext",
        name: "cc",
        type: "tuple",
      },
    ],
    name: "getOracle",
    outputs: [
      {
        internalType: "contract IOracle",
        name: "dest",
        type: "address",
      },
      {
        components: [
          {
            internalType: "contract IController",
            name: "controller",
            type: "address",
          },
          {
            internalType: "address[15]",
            name: "cache",
            type: "address[15]",
          },
        ],
        internalType: "struct ControllerContextLib.ControllerContext",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IController",
            name: "controller",
            type: "address",
          },
          {
            internalType: "address[15]",
            name: "cache",
            type: "address[15]",
          },
        ],
        internalType: "struct ControllerContextLib.ControllerContext",
        name: "cc",
        type: "tuple",
      },
    ],
    name: "getPvpController",
    outputs: [
      {
        internalType: "contract IPvpController",
        name: "dest",
        type: "address",
      },
      {
        components: [
          {
            internalType: "contract IController",
            name: "controller",
            type: "address",
          },
          {
            internalType: "address[15]",
            name: "cache",
            type: "address[15]",
          },
        ],
        internalType: "struct ControllerContextLib.ControllerContext",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IController",
            name: "controller",
            type: "address",
          },
          {
            internalType: "address[15]",
            name: "cache",
            type: "address[15]",
          },
        ],
        internalType: "struct ControllerContextLib.ControllerContext",
        name: "cc",
        type: "tuple",
      },
    ],
    name: "getReinforcementController",
    outputs: [
      {
        internalType: "contract IReinforcementController",
        name: "dest",
        type: "address",
      },
      {
        components: [
          {
            internalType: "contract IController",
            name: "controller",
            type: "address",
          },
          {
            internalType: "address[15]",
            name: "cache",
            type: "address[15]",
          },
        ],
        internalType: "struct ControllerContextLib.ControllerContext",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IController",
            name: "controller",
            type: "address",
          },
          {
            internalType: "address[15]",
            name: "cache",
            type: "address[15]",
          },
        ],
        internalType: "struct ControllerContextLib.ControllerContext",
        name: "cc",
        type: "tuple",
      },
    ],
    name: "getRewardsPool",
    outputs: [
      {
        internalType: "contract IRewardsPool",
        name: "dest",
        type: "address",
      },
      {
        components: [
          {
            internalType: "contract IController",
            name: "controller",
            type: "address",
          },
          {
            internalType: "address[15]",
            name: "cache",
            type: "address[15]",
          },
        ],
        internalType: "struct ControllerContextLib.ControllerContext",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IController",
            name: "controller",
            type: "address",
          },
          {
            internalType: "address[15]",
            name: "cache",
            type: "address[15]",
          },
        ],
        internalType: "struct ControllerContextLib.ControllerContext",
        name: "cc",
        type: "tuple",
      },
    ],
    name: "getStatController",
    outputs: [
      {
        internalType: "contract IStatController",
        name: "dest",
        type: "address",
      },
      {
        components: [
          {
            internalType: "contract IController",
            name: "controller",
            type: "address",
          },
          {
            internalType: "address[15]",
            name: "cache",
            type: "address[15]",
          },
        ],
        internalType: "struct ControllerContextLib.ControllerContext",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IController",
            name: "controller",
            type: "address",
          },
          {
            internalType: "address[15]",
            name: "cache",
            type: "address[15]",
          },
        ],
        internalType: "struct ControllerContextLib.ControllerContext",
        name: "cc",
        type: "tuple",
      },
    ],
    name: "getStoryController",
    outputs: [
      {
        internalType: "contract IStoryController",
        name: "dest",
        type: "address",
      },
      {
        components: [
          {
            internalType: "contract IController",
            name: "controller",
            type: "address",
          },
          {
            internalType: "address[15]",
            name: "cache",
            type: "address[15]",
          },
        ],
        internalType: "struct ControllerContextLib.ControllerContext",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IController",
            name: "controller",
            type: "address",
          },
          {
            internalType: "address[15]",
            name: "cache",
            type: "address[15]",
          },
        ],
        internalType: "struct ControllerContextLib.ControllerContext",
        name: "cc",
        type: "tuple",
      },
    ],
    name: "getTreasury",
    outputs: [
      {
        internalType: "contract ITreasury",
        name: "dest",
        type: "address",
      },
      {
        components: [
          {
            internalType: "contract IController",
            name: "controller",
            type: "address",
          },
          {
            internalType: "address[15]",
            name: "cache",
            type: "address[15]",
          },
        ],
        internalType: "struct ControllerContextLib.ControllerContext",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IController",
            name: "controller",
            type: "address",
          },
          {
            internalType: "address[15]",
            name: "cache",
            type: "address[15]",
          },
        ],
        internalType: "struct ControllerContextLib.ControllerContext",
        name: "cc",
        type: "tuple",
      },
    ],
    name: "getUserController",
    outputs: [
      {
        internalType: "contract IUserController",
        name: "dest",
        type: "address",
      },
      {
        components: [
          {
            internalType: "contract IController",
            name: "controller",
            type: "address",
          },
          {
            internalType: "address[15]",
            name: "cache",
            type: "address[15]",
          },
        ],
        internalType: "struct ControllerContextLib.ControllerContext",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IController",
        name: "controller",
        type: "address",
      },
    ],
    name: "init",
    outputs: [
      {
        components: [
          {
            internalType: "contract IController",
            name: "controller",
            type: "address",
          },
          {
            internalType: "address[15]",
            name: "cache",
            type: "address[15]",
          },
        ],
        internalType: "struct ControllerContextLib.ControllerContext",
        name: "cc",
        type: "tuple",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
] as const;

export class FacadeControllerContextLib__factory {
  static readonly abi = _abi;
  static createInterface(): FacadeControllerContextLibInterface {
    return new Interface(_abi) as FacadeControllerContextLibInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): FacadeControllerContextLib {
    return new Contract(
      address,
      _abi,
      runner
    ) as unknown as FacadeControllerContextLib;
  }
}
